import React, { createContext, useReducer } from 'react';

interface ThemeState {
    darkMode: boolean;
}

interface Context {
    dispatch: React.Dispatch<ThemeActionInterface>;
    state: ThemeState;
}

type ThemeActionType = 'LIGHTMODE' | 'DARKMODE';

export interface ThemeActionInterface {
    type: ThemeActionType;
}

const initialState: Context = {
    state: { darkMode: false },
    dispatch: () => null,
};

export const ThemeContext = createContext<Context>(initialState);

const themeReducer = (state: ThemeState, action: ThemeActionInterface) => {
    switch (action.type) {
        case 'LIGHTMODE':
            return { darkMode: false };
        case 'DARKMODE':
            return { darkMode: true };
        default:
            return state;
    }
};

interface ThemeProviderProps {
    children: React.ReactNode;
}

export function ThemeProvider(props: ThemeProviderProps) {
    const [state, dispatch] = useReducer(themeReducer, initialState.state);

    return (
        <ThemeContext.Provider value={{ state, dispatch }}>{props.children}</ThemeContext.Provider>
    );
}
